<template>
  <admin-only redirectOnNotAuthorized>
    <v-container fluid>
      <v-toolbar color="white">
        <h2 class="headline ml-5"> <v-icon>mdi-account-supervisor</v-icon> Personen</h2>
        <!-- <v-btn
          @click="showMetadataDefinitions = true"
          color="blue darken-4"
          dark
          small
          absolute
          right
          fab
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn> -->
      </v-toolbar>

      <v-card class="mt-4">
        <v-simple-table>
          <thead>
          <tr>
            <th class="text-left">Name</th>
            <th v-for="metadata in metadataList" :key="metadata">
              {{metadata}}
            </th>
            <th class="text-left">Aktives Zeitmodell</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in usersSettings" :key="user.email">
            <td>{{user.name}}</td>
            <th v-for="m in user.metadata" :key="m.name">
              <Metadata
                  :name="m.name"
                  v-model="m.value"
                  :metadataDefinition="m.metadataDefinition"
              />
            </th>
            <td>
              {{getUserActiveTimeModelName(user)}}
              <v-btn
                  @click="selectedUser = user"
                  color="blue ligthen-4"
                  dark
                  small
                  absolute
                  right
              >
                <v-icon>mdi-playlist-edit</v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
        <v-card-actions>
          <v-btn color="primary" :disabled="!valid" @click="save">Speichern</v-btn>
        </v-card-actions>
      </v-card>
      <vue-slideout-panel
        v-model="showMetadataDefinitions"
        :widths="['85%']"
        closeHtml=""
        @close="showMetadataDefinitions=false"
        :styles="[{},{},{}, {display: 'none'}]"
      >
        <user-metadata-definitions />
      </vue-slideout-panel>
    </v-container>
    <v-dialog v-model="showUserTimeModelsModal" :persistent="true" max-width="800px">
      <user-time-models
        v-if="showUserTimeModelsModal"
        :initialUser="selectedUser"
        @dismiss="onUserTimeModelUpdated"
      />
    </v-dialog>
  </admin-only>
</template>

<script>

import util from '../util';
import timeparkApi from '../timeparkApi';
import UserMetadataDefinitions from './metadata/UserMetadataDefinitions';
import UserTimeModels from './timeModels/UserTimeModels';
import VueSlideoutPanel from 'vue-slideout-panel';
import Metadata from './metadata/Metadata';
import moment from 'moment';
import {mapState} from "vuex";

export default {
  name: 'Personen',
  components: {
    Metadata,
    UserMetadataDefinitions,
    UserTimeModels,
    VueSlideoutPanel,
  },
  watch: {
    users() {
      this.reloadData();
    },
    userMetadataDefinitions() {
      this.reloadData();
    },
    usersSettings: {
      handler() {
        this.computeValidity();
      },
      deep: true,
    },
  },
  mounted() {
    this.reloadData();
  },
  computed: {
    timeModels() {
      return [
        {
          id: null,
          name: ' - ',
        }
        ,
        ...this.$store.state.timeModels
      ]
    },
    showUserTimeModelsModal: {
      get() {
        return this.selectedUser !== null;
      },
      set(newValue) {
        this.selectedUser = newValue;
      }
    },
    ...mapState(['userMetadataDefinitions', 'users']),
  },
  methods: {
    getUserActiveTimeModelName(user) {
      if (!user) {
        return '';
      }

      const utcNow = moment().utc();

      let timeModelId = user.timeModelId;

      if (user.timeModels && user.timeModels.length >= 0) {
        const activeTimeModel = user.timeModels.find(x =>
          moment.utc(x.start).isSameOrAfter(utcNow) && moment.utc(x.end).isSameOrBefore(utcNow));

        if (activeTimeModel) {
          timeModelId = activeTimeModel.timeModelId;
        }
      }

      return this.timeModels.find(x => x.id === timeModelId).name;
    },
    computeValidity() {
      this.valid = this.usersSettings.length > 0 &&
        this.usersSettings.every(u =>
          u.metadata.length <= 0 ||
          u.metadata.every(m => !m.metadataDefinition.mandatory || m.value)
        );
    },
    computeMetadataList() {
      if (!this.usersSettings || this.usersSettings.length <= 0) {
        return [];
      }

      return this.usersSettings[0].metadata.map(x => x.name);
    },
    createLocalDataFromApiResult(apiResult) {
      this.usersSettings = this.users.map(u => {

        const userSettings = apiResult.data.find(x => x.email === u.email);

        return {
          name: u.name ? u.name : u.email,
          email: u.email,
          timeModelId: userSettings ? userSettings.timeModelId : null,
          metadata: util.combineMetadataWithMetadataDefinitions(
            userSettings ? userSettings.metadata : [],
            this.userMetadataDefinitions),
          timeModels: userSettings ? userSettings.timeModels : [],
        };
      });

      this.metadataList = this.computeMetadataList();

      this.computeValidity();
    },
    async reloadData() {
      const apiResult = await timeparkApi.getUserSettings();
      this.createLocalDataFromApiResult(apiResult);
    },
    async save() {
      const apiResult = await timeparkApi.bulkSaveOrUpdateUserSettings(this.usersSettings);
      this.createLocalDataFromApiResult(apiResult);
    },
    onUserTimeModelUpdated() {
      this.selectedUser = null;
      this.reloadData();
    },
  },
  data: () => ({
    valid: false,
    showMetadataDefinitions: false,
    usersSettings: [],
    metadataList: [],
    selectedUser: null,
  }),
};
</script>
